import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionA');
    return (
        <div className={styles.TheComp}>
            <EfSection
                theme="white"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                // pc="https://websiteoss.ecoflow.com/upload/image/1725605041186/pc_Long-lasting.jpg"
                // h5="https://websiteoss.ecoflow.com/upload/image/1725605096374/m_Long-lasting.jpg"
            />
            <div className="blue-text">
                <span className="big blue">6000</span>
                <span className="icon blue">+</span>
                <span className="unit blue">{t('text2')}</span>
            </div>
        </div>
    );
}
